export function formatAtecoCode(code: string) {
  if(code == null){
    return ""
  }
  const splittedCode = code.match(/..?/g);
  return splittedCode[0] + "." + splittedCode[1] + "." + splittedCode[2];
}
